<template>
  <div>
    <Header />
    <div class="bg-light pb-5">
      <div class="container">
        <div class="section-header-breadcrumb">
          <h2 class="title-page">Programme de fidélité</h2>
          <a href="#">Accueil</a> <i class="ti ti-angle-right"></i>
          <span> Programme de fidélité</span>
        </div>

        <div class="row mt-5 mb-5 justify-content-center align-items-center justify-content-center">
          <div class="col-lg-7">
            <h2 class="font-32 blue-color font-bold text-center">Notre programme de fidélité</h2>
            <p class="text-center mb-5">Transformez vos commandes en avantages exclusifs.</p>
            <img :src="fidelite" class="round-10 w-100" />

            <p class="text-center mt-5 mb-5">
              Notre programme de fidélité a été conçu pour récompenser votre engagement et vous offrir des avantages
              supplémentaires à chaque commande. Gagnez des points à chaque achat et utilisez-les pour réduire vos coûts
              ou accéder à des offres exclusives.
            </p>

            <h3 class="font-32 blue-color font-bold text-center mb-5 pb-5">Comment ça fonctionne ?</h3>

            <div class="steps-block mt-5">
              <div class="step-line"><img :src="line" /></div>

              <div class="step-item bottom step-item-left text-center">
                <span class="step-icon">
                  <img :src="payment" />
                </span>
                <p class="mb-0">Passez commande</p>
                <strong class="blue-color font-16 font-bold">Étape 1</strong>
              </div>

              <div class="step-item top text-center">
                <span class="step-icon">
                  <img :src="card" />
                </span>
                <strong class="blue-color font-16 font-bold">Étape 2</strong>
                <p class="mb-0">Consultez vos points</p>
              </div>

              <div class="step-item bottom step-item-right text-center">
                <span class="step-icon">
                  <img :src="points" />
                </span>
                <p class="mb-0">Utilisez vos points</p>
                <strong class="blue-color font-16 font-bold">Étape 3</strong>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-5 pb-5 align-items-center">
          <div class="col-lg-5">
            <img :src="avantages" class="w-100 round-10" />
          </div>

          <div class="col-lg-5">
            <h3 class="font-bold font-22 blue-color mb-4">Vos avantages en détail</h3>

            <h4 class="blue-color font-bold font-16">Accumulation rapide</h4>
            <p class="mb-4">
              Chaque commande vous rapproche de plus d’avantages. Plus vous achetez, plus vous gagnez !
            </p>

            <h4 class="blue-color font-bold font-16">Réductions directes</h4>
            <p class="mb-4">Utilisez vos points pour réduire vos factures jusqu’à -50%.</p>

            <h4 class="blue-color font-bold font-16">Accès prioritaire</h4>
            <p class="mb-4">Profitez d’offres réservées uniquement aux membres du programme.</p>

            <h4 class="blue-color font-bold font-16">Sans engagement</h4>
            <p class="mb-4">
              Aucune inscription nécessaire – tous nos clients professionnels bénéficient automatiquement du programme.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-light-1 pt-5 pb-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-7">
            <h2 class="font-32 blue-color font-bold text-center">Exemple de conversion des points</h2>
            <p class="font-16 text-center orange-color font-bold">Exemple pratique</p>

            <div class="number-text-block text-center mt-5">
              <h3 class="mb-3">
                <strong class="blue-color">1€ dépensé =</strong>
                <strong class="orange-color"> 1 point</strong>
              </h3>
              <h3 class="mb-5">
                <strong class="blue-color">100 points =</strong>
                <strong class="orange-color">5€ de remise</strong>
              </h3>
              <p class="mt-5 mb-4">
                Si vous avez des questions ou souhaitez en savoir plus sur le programme,<br />
                notre service client est là pour vous aider.
              </p>

              <a href="#" class="btn btn-orange">Découvrir le programme de fidélité</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-5 pb-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <h2 class="font-32 blue-color font-bold text-center">
              Les produits recommandés par votre vétérinaire,<br />
              depuis chez vous
            </h2>

            <div class="row mt-5 justify-content-center align-items-center">
              <div class="col-lg-4">
                <div class="d-flex flex-column justify-content-center gap-3 align-items-center">
                  <img :src="support" class="w-30" />
                  <p class="text-center font-bold blue-color">Un service client à votre écoute</p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="d-flex flex-column justify-content-center gap-3 align-items-center">
                  <img :src="pays" class="w-30" />
                  <p class="text-center font-bold blue-color">100% made in France</p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="d-flex flex-column justify-content-center gap-3 align-items-center">
                  <img :src="delivery" class="w-30" />
                  <p class="text-center font-bold blue-color">Livraison sous 48 à 72h</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="question-list bg-light-1">
      <div class="container">
        <div class="content col-sm-12 col-md-12 col-lg-12">
          <Question />
        </div>
      </div>
    </div>

    <div class="pt-5 pb-5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-5">
            <h2 class="font-32 blue-color font-bold">Restez informé des dernières promotions et nouveautés !</h2>
            <p>
              Inscrivez-vous à notre newsletter pour recevoir des offres exclusives et des conseils professionnels
              adaptés à votre clinique.
            </p>
          </div>

          <div class="col-lg-5 offset-lg-2">
            <form>
              <div class="form-input email-input">
                <input type="email" placeholder="email" class="form-control" />
                <a href="" class="btn btn-orange btn-circle"><img :src="send" /></a>
              </div>
              <p>êtes-vous propriétaire d’un :</p>

              <div class="d-flex gap-3">
                <label
                  v-for="option in options"
                  :key="option"
                  :class="['check-button', { active: selected.includes(option) }]"
                >
                  <input type="checkbox" :value="option" v-model="selected" hidden />
                  <span class="label-text">{{ option }}</span>
                  <span class="check-icon" v-if="selected.includes(option)"><i class="ti ti-check-box ps-2"></i></span>
                </label>
              </div>
              <p class="blue-color mt-3">
                Nous respectons votre confidentialité.<br />
                Désinscription à tout moment.
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
  import Header from "@/components/Header.vue";
  import Footer from "@/components/Footer.vue";
  import line from "@/assets/images/arrow-line.svg";
  import payment from "@/assets/images/payment.svg";
  import card from "@/assets/images/card.svg";
  import points from "@/assets/images/points.svg";
  import fidelite from "@/assets/images/fidelte.jpg";
  import avantages from "@/assets/images/avantages.jpg";
  import support from "@/assets/images/support.svg";
  import pays from "@/assets/images/pays.svg";
  import delivery from "@/assets/images/delivery.svg";
  import send from "@/assets/images/send.svg";
  import Question from "@/components/Question.vue";
  export default {
    components: {
      Header,
      Footer,
      Question,
    },
    data() {
      return {
        fidelite,
        avantages,
        payment,
        card,
        points,
        line,
        support,
        pays,
        send,
        delivery,
        options: ["chien", "Chat", "cheval"],
        selected: [],
      };
    },
  };
</script>
